import * as dataStore from './data-store.js';
import * as dateUtils from './date-utils.js';

const googleDocIdLeaderboardGP2023 =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vRbNcBwX9b95wx21s-8M3Abls5zPBj3WHvOFaak7jofx431ayebgdMHVv8c2Rr-ZOqtqjZHjCFrd31W/pub?gid=0&single=true&output=csv';

const googleDocIdLeaderboardGP2024 = 
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vTAjZkRTQiaKHKWxBpDdNWH7eL_dhHa9ApaiuOprWUXEG3vcrIr6xgKmbwUWQ_4FV24taJDO7XTR-K2/pub?gid=0&single=true&output=csv';

const googleDocIdLeaderboardGP2025 = 
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vT-spkDqeKdWvyk9_TEvDPy3IDglNBxM9i008Vy4_CZgHwzuOyG7N22uW_P7m66gHQPjwI8T9PCTrUp/pub?gid=0&single=true&output=csv';

const googleMonthsTabsIdsGP = ['2050273654', '894964860', '1029443492', '1265733486', '637691318', '671778284','14808792','1818273324', '743798872','111029067','137950792','1778547717'];

let appCallback = null;

export function setCallback(cb) {
  appCallback = cb;
}

export function getCallback() {
  return appCallback;
}

function getGoogleDocIdLeaderboardGP(year) {
  console.log('getGoogleDocIdLeaderboardGP', year)
  if (year == 2023) {
    return googleDocIdLeaderboardGP2023
  } else if (year == 2024) {
  return googleDocIdLeaderboardGP2024
  } else {
    return googleDocIdLeaderboardGP2025
  }
}

function getGoogleDocIdGP(year) {
  if (year == 2023) {
    return '2PACX-1vRbNcBwX9b95wx21s-8M3Abls5zPBj3WHvOFaak7jofx431ayebgdMHVv8c2Rr-ZOqtqjZHjCFrd31W'
  } else if (year == 2024) {
  return '2PACX-1vTAjZkRTQiaKHKWxBpDdNWH7eL_dhHa9ApaiuOprWUXEG3vcrIr6xgKmbwUWQ_4FV24taJDO7XTR-K2'
  } else {
    return '2PACX-1vT-spkDqeKdWvyk9_TEvDPy3IDglNBxM9i008Vy4_CZgHwzuOyG7N22uW_P7m66gHQPjwI8T9PCTrUp'
  }
}

export async function showLeaderboard(year, screenWidth) {
  let maxCol = 0;
  let tableResults = document.getElementById('table-leaderboard');
  tableResults.innerHTML = '';
  let showLeaderboardColumns = [
    0, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 33
  ];
  if (year == 2023) {
    showLeaderboardColumns = [
      0, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 32
    ];
  
  }
  const monthColumns = [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27];
  const totalColumn = 25;
  // console.log('Showing Laderboard with width:', screenWidth);
  if (screenWidth < 600) {
    showLeaderboardColumns = [0, 15, 29, 30];
  }
  await dataStore.loadData(getGoogleDocIdLeaderboardGP(year)).then((data1) => {
    // console.log(data1);
    data1.forEach((row, rowIndex) => {
      let tr = tableResults.insertRow();
      // console.log(row);
      row.forEach((col, colIndex) => {
        // Only show people with points
        if (row[30] > 0 || rowIndex == 0) {
          // Add position column
          if (colIndex == 0) {
            if (rowIndex == 0) {
              tr.appendChild(document.createElement('th'));
            } else {
              tr.insertCell().innerHTML = rowIndex;
            }
          }
          if (rowIndex > 0 && monthColumns.includes(colIndex)) {
            // console.log(rowIndex, colIndex, col);
            if (col !== '' && colIndex > maxCol) {
              maxCol = colIndex;
            }
          }
          if (showLeaderboardColumns.includes(colIndex)) {
            if (rowIndex == 0) {
              let th = document.createElement('th');
              const monthNo = monthColumns.indexOf(colIndex);
              if (monthNo > -1) {
                th.className = 'month-result';
                col = col.substr(0, 3);
                th.innerHTML = `<span><abbr>${col}</abbr></span>`;
                th.onclick = () => {
                  this.getCallback().onMonthSelect(monthNo + 1);
                };
              } else {
                th.innerHTML = col;
              }
              tr.appendChild(th);
            } else {
              let td = tr.insertCell();
              if (colIndex == totalColumn) {
                td.className = 'total-points';
              }
              if (monthColumns.includes(colIndex)) {
                // td.className = 'month-result';
                if (row[colIndex - 15] == '1') {
                  td.className = ' gold-card';
                }
              }
              td.innerHTML = col;
              // Gold Card
              if (year == 2023 && colIndex == 32 || year >= 2023 && colIndex == 33) {
                const goldCardCount = col;
                if (goldCardCount == 2) {
                  td.innerHTML =
                    '<i class="fa fa-xl fa-ticket"></i><i class="fa fa-xl fa-ticket"></i>';
                } else if (goldCardCount == 1) {
                  td.innerHTML = '<i class="fa fa-xl fa-ticket"></i>';
                } else {
                  td.innerHTML = '';
                }
              }
            }
          }
        }
      });
    });
  });
  return monthColumns.indexOf(maxCol) + 1;
}

export async function showMonth(year, monthNo, screenWidth) {
  document.getElementById('month-name').innerText = dateUtils.longmonth(monthNo);
  let showColumns = [0, 2, 4, 6, 7, 8];
  let table2 = document.getElementById('table-month');
  table2.innerHTML = '';
  document.getElementById('race-name').innerHTML = '';
  if (screenWidth < 600) {
    showColumns = [0, 2, 6, 7];
  }
  const docId = dataStore.googleTabUrl(
    googleMonthsTabsIdsGP,
    getGoogleDocIdGP(year),
    monthNo
  );
  // console.log(showColumns);
  await dataStore.loadData(docId).then((data1) => {
    // console.log(data1);
    let headerDetails = data1[0];
    let raceName = headerDetails[0];
    let raceDistance = headerDetails[6];
    let raceDifficulty = headerDetails[7]
    // raceName = raceName.substr(0,raceName.indexOf(','))
    document.getElementById('month-name').innerText = `${dateUtils.longmonth(monthNo)}`;
    document.getElementById('race-name').innerHTML = `<span>${raceName}</span><span class="sep">&bull;</span><span>${raceDistance}</span><span class="sep">&bull;</span><span>${raceDifficulty}</span>`;
    data1.forEach((row, rowIndex) => {
      let tr = table2.insertRow();
      // console.log(row);
      row.forEach((col, colIndex) => {
        if (rowIndex > 0) {
          // Add position column
          // if (colIndex == 0) {
          //   if (rowIndex == 1) {
          //     tr.appendChild(document.createElement('th'));
          //   } else {
          //     tr.insertCell().innerHTML = rowIndex - 1;
          //   }
          // }
          if (showColumns.includes(colIndex)) {
            if (rowIndex == 1) {
              let th = document.createElement('th');
              th.innerHTML = col;
              tr.appendChild(th);
            } else {
              let td = tr.insertCell();
              td.innerHTML = col;
              if (colIndex == 6 && col !== null) {
                const diffPercentage = parseFloat(col);
                if (diffPercentage < -1) {
                  td.className = 'time-neg';
                } else if (diffPercentage > 1) {
                  td.className = 'time-pos';
                } else {
                  td.className = 'time-equal';
                }
              }
              if (colIndex == 8 && col !== '') {
                td.innerHTML = '<i class="fa fa-xl fa-ticket"></i>';
              }
            }
          }
        }
      });
    });
  });
  return true;
  //}
}
